module.exports = __webpack_public_path__ + "img/add.6ad41b8b.svg";